import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-confirm-dialogue',
  imports: [MatDialogModule,CommonModule],
  templateUrl: './confirm-dialogue.component.html',
  styleUrl: './confirm-dialogue.component.scss'
})
export class ConfirmDialogueComponent {
constructor(
    public dialogRef: MatDialogRef<ConfirmDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
